import { FamilyBar, type Copy } from '@beyond-js/ui/react';
import { useI18n } from '@cdn/i18n';

/**
 * The copy of the family bar in the selected language: the family's own set (`FamilyBar.labels`, English and
 * Spanish since `@beyond-js/ui` 0.7.2), the same words as every Beyond product. CDN adds no entry of its own;
 * product names are not translated. The set is one frozen object per language, so the bar is rebuilt only when
 * the language changes.
 */
export function useFamilyLabels(): Copy {
	const { locale } = useI18n();
	return FamilyBar.labels[locale.code === 'es' ? 'es' : 'en'];
}
